import { Input } from '@/components/atoms';
import { DatePeriodSelect } from '@/components/molecules';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms';

interface TransactionFiltersProps {
  dateRange: string;
  statusFilter: string;
  searchQuery: string;
  onDateRangeChange: (value: string) => void;
  onStatusFilterChange: (value: string) => void;
  onSearchChange: (value: string) => void;
}

export const TransactionFilters = ({
  dateRange,
  statusFilter,
  searchQuery,
  onDateRangeChange,
  onStatusFilterChange,
  onSearchChange,
}: TransactionFiltersProps) => {
  return (
    <div className="flex justify-end flex-wrap items-center gap-4">
      <DatePeriodSelect
        value={dateRange}
        onValueChange={onDateRangeChange}
        triggerClassName="border-none bg-muted/30"
      />

      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-44 border-none bg-muted/30">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All status</SelectItem>
          <SelectItem value="success">Successful</SelectItem>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="failed">Failed</SelectItem>
        </SelectContent>
      </Select>

      <Input
        value={searchQuery}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search..."
        className="max-w-xs border-none bg-muted/30"
      />
    </div>
  );
};
